import axios from "axios";
import { axiosGet, axiosPost } from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/integrations";

const authHeaders = () => ({ Authorization: localStorage.getItem("adminToken") });

export default {
  scopes: () => axiosGet(`${BASE_URL}/scopes`),
  settings: () => axiosGet(`${BASE_URL}/settings`),
  saveSettings: (settings) => axiosPost(`${BASE_URL}/settings`, { settings }),
  list: (params = {}) => axiosGet(BASE_URL, params),
  detail: (id) => axiosGet(`${BASE_URL}/${id}`),
  create: (payload) => axiosPost(BASE_URL, payload),
  update: (id, payload) => axiosPost(`${BASE_URL}/${id}/update`, payload),
  updateStatus: (id, status) => axiosPost(`${BASE_URL}/${id}/status`, { status }),
  rotate: (id) => axiosPost(`${BASE_URL}/${id}/rotate`),
  addIp: (id, payload) => axiosPost(`${BASE_URL}/${id}/ips`, payload),
  updateIpStatus: (id, ipId, status) => axiosPost(`${BASE_URL}/${id}/ips/${ipId}/status`, { status }),
  removeIp: async (id, ipId) => (await axios.delete(`${BASE_URL}/${id}/ips/${ipId}`, { headers: authHeaders() })).data,
  replaceScopes: (id, scopes) => axiosPost(`${BASE_URL}/${id}/scopes`, { scopes }),
  revokeToken: (id, tokenId, reason) => axiosPost(`${BASE_URL}/${id}/tokens/${tokenId}/revoke`, { reason }),
  logs: (id) => axiosGet(`${BASE_URL}/${id}/logs`),
};
